module.exports = __webpack_public_path__ + "jp.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/jp.svg
// module id = 629
// module chunks = 0